<!-- zoom banner -->
<template>
  <div class="zoom-banner">
    <div>
      <h1 v-if="appDetail.mentorResultTimeStr">Starting time：{{appDetail.mentorResultTimeStr}} ({{appDetail.mentorZone|zoneTitleMap}})</h1>
      <p>After the appointment is completed, please return to MSP to complete the feedback form.</p>
      <div class="zoom-banner-item">
        <div>
          <span v-if="isPackageId && (appDetail.module === 'MODULE_1')">PS Brainstorming</span>
          <span v-else>{{appDetail.module | moduleTitleMap }}</span> (Max time)：{{remainTime.maxTime}}mins</div>
        <div>
          <span v-if="isPackageId && (appDetail.module === 'MODULE_1')">PS Brainstorming</span>
          <span v-else>{{appDetail.module | moduleTitleMap }}</span> (Used time)：{{remainTime.usedTime}}mins</div>
      </div>
      <div class="zoom-banner-item">
        <div>Expected discussion time：{{appDetail.predictTime}}mins</div>
        <div>
          <span v-if="isPackageId && (appDetail.module === 'MODULE_1')">PS Brainstorming</span>
          <span v-else>{{appDetail.module | moduleTitleMap }}</span> (Remaining time)：{{remainTime.remainTime}}mins</div>
      </div>
      <template v-if="appDetail.mentorZoom && (appDetail.statu==='INCOMPLETE' || appDetail.statu==='TO_FEEDBACK')">
        <div class="zoom-link">Zoom link: {{appDetail.mentorZoom}}</div>
        <div style="color: #fff;">Meeting ID: {{meetingId}}</div>
        <div class="zoom-banner-btn">
          <Button class="zlr-btn-primary"
                  @click="zoomConfirm">Open Zoom</Button>
        </div>
      </template>
    </div>
    <!--Open Zoom 确认操作-->
    <zlr-modal v-model="zoomModal" style='width: 100%;min-width: 660px;'>
      <div class="zoom-confirm">
        <div class='zoom-confirm-desc'>Please be aware of the service remaining time before video mentoring with mentees. The exceeded time spent you claim won't be reimbursed by ZLR. If you meet any special situations please email mentorhelp@zlrvaleon.com.</div>
        <div class="zoom-confirm-btn">
          <Button class="zlr-btn-default" @click="zoomHandle"
            >Confirm</Button>
            <Button class="zlr-btn-default" @click="zoomModal = false"
            >Close</Button>
        </div>
      </div>
    </zlr-modal>
  </div>
</template>

<script>
// api
import { getAppRemainTime } from '@/api/appointment'
import ZlrModal from '_c/modal/modal'
import { getZoomMeetingId } from '../../../api/appointment'

export default {
  name: 'mentee-zoom-banner',
  props: ['appDetail', 'isPackageId'],
  components: {
    ZlrModal
  },
  data () {
    return {
      remainTime: {},
      zoomModal: false,
      meetingId: undefined
    }
  },
  computed: {},
  mounted () {
    this.getAppRemainTime()
    if (this.appDetail && this.appDetail.zoomUrl && this.appDetail.zoomUrl.id && this.appDetail.zoomUrl.value) {
      getZoomMeetingId(this.appDetail.zoomUrl.id, this.appDetail.zoomUrl.value).then(res => {
        if (res.code === 0) {
          this.meetingId = res.data.model.meetingId
        }
      })
    }
  },
  methods: {
    getAppRemainTime () {
      let appDetail = this.appDetail
      getAppRemainTime({
        'id': appDetail.id
      }).then(res => {
        this.remainTime = res.data.model
      })
    },
    // Open Zoom操作
    zoomConfirm () {
      this.zoomModal = true
    },
    zoomHandle () {
      let zoom = this.appDetail.mentorZoom
      window.open(zoom, '_blank ')
    }
  },
  watch: {
    appDetail: {
      handler () {
        this.getAppRemainTime()
      }
    }
  }
}
</script>
<style lang='less' scoped>
.zoom-confirm {
  width: 600px;
  .zoom-confirm-desc {
    text-indent: 2em;
    font-size: 14px;
  }
  .zoom-confirm-btn {
    display: block;
    padding-top: 20px;
    .zlr-btn-default {
      margin-right: 10px;
    }
  }
}
</style>
